export const LOGGED_IN_USER_UPDATE = 'at/loggedInUser/LOGGED_IN_USER_UPDATE'



// WEBPACK FOOTER //
// ./web/js/loggedInUser/actionTypes.js